import { render } from "./MabdLogo.vue?vue&type=template&id=5418f7fd"
import script from "./MabdLogo.vue?vue&type=script&lang=js"
export * from "./MabdLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__